import { Component, OnInit, OnDestroy } from "@angular/core";
import { AppService } from "../services/app.service";
import { chkLength as chkLengthUtil } from "../utils/format-util";
import { SupportService } from "../services/support-service";
import { Router } from "@angular/router";
import { formatDate } from "@angular/common";

import * as moment from "moment-timezone";

@Component({
  selector: "app-rescheduled-patient",
  templateUrl: "./rescheduled-patient.component.html",
})
export class RescheduledPatientComponent implements OnInit, OnDestroy {
  rowsData: any[] = [];
  columnsData: any = [];
  row: any = {};
  destroyComponent: any = {};
  totalItems = 0;
  maxSize = 10;
  maxSizeItem = 10;
  pageOrder: any = {};
  currentPage = 1;
  page: number;
  errorMessage = "";

  fromDate: string;
  // toDate: string;
  selectedTab = "";
  newDate: Date;
  constructor(
    private appService: AppService,
    private supportService: SupportService,
    private router: Router
  ) {}

  ngOnInit() {
    this.checkselectedtab(sessionStorage.getItem("currentTab"));
    this.getRowsData();
    this.generate();
    this.getColumnOrder();
    this.supportService.headerSubLittle.next("Home");
  }
  private getRowsData() {
    this.rowsData = [
      {
        title: "First Name",
        sorting: true,
        name: "patientFirstName",
        dateFitler: false,
      },
      {
        title: "Last Name",
        sorting: true,
        name: "patientLastName",
        dateFitler: false,
      },
      {
        title: "Date Booked",
        sorting: true,
        name: "createdOn",
        dateFitler: true,
      },
      {
        title: "Date of Service",
        sorting: true,
        name: "scheduledOnStr",
        dateFitler: true,
      },
      {
        title: "Heard About?",
        sorting: false,
        name: "hearedAboutUs",
        dateFitler: false,
      },
    ];
    this.row = {
      param1: "patientFirstName",
      param2: "patientLastName",
      param3: "createdOn",
      param4: "scheduledOnStr",
      param5: "hearedAboutUs",
    };
    this.pageOrder = {
      type: "rescheduled",
      fromDate: this.fromDate,
      toDate: this.fromDate,
      pageNumber: 1,
      pageRecord: this.maxSizeItem,
      search: "",
      sortColumn: "",
      sortType: "",
    };
  }

  checkselectedtab(selectedTab) {
    if (selectedTab === "today") {
      this.fromDate = formatDate(new Date(), "yyyy-MM-dd", "en");
    }
    if (selectedTab === "tomorrow") {
      this.newDate = new Date();
      this.newDate.setDate(this.newDate.getDate() + 1);
      this.fromDate = formatDate(this.newDate, "yyyy-MM-dd", "en");
    }
    if (selectedTab === "yesterday") {
      this.newDate = new Date();
      this.newDate.setDate(this.newDate.getDate() - 1);
      this.fromDate = formatDate(this.newDate, "yyyy-MM-dd", "en");
    }
    if (selectedTab === "dayafter") {
      this.newDate = new Date();
      this.newDate.setDate(this.newDate.getDate() + 2);
      this.fromDate = formatDate(this.newDate, "yyyy-MM-dd", "en");
    }
  }

  private getColumnData(param?, blur?) {
    this.appService.getgriddata(param).subscribe(
      (res: any) => {
        this.columnsData = [];
        if (blur && blur === "blur") {
          this.currentPage = 1;
        }
        if (res && res.entity) {
          this.totalItems = res["count"];
          res.entity.forEach((obj) => {
            if (obj) {
              const param = this.getParamData(obj);
              this.columnsData.push(param);
            }
          });
        }
      },
      (err) => {
        if (err.error.error === "invalid_token") {
          this.appService.sessionOut(err);
        }
      }
    );
  }
  private getParamData(obj) {
    const param: any = {};
    Object.keys(this.row).forEach((key, i) => {
      i = i + 1;
      param["param" + i] = obj[this.row["param" + i]];
    });
    return param;
  }

  chkLength(data) {
    return chkLengthUtil(data);
  }
  private getColumnOrder() {
    this.destroyComponent[
      "orderSubsciber"
    ] = this.supportService.gridSortingHeader.subscribe((result: any) => {
      if (result && (result["name"] || result["order"])) {
        this.pageOrder["sortColumn"] = result["name"];
        this.pageOrder["sortType"] = result["order"];
        this.getColumnData(this.pageOrder);
      }
    });
  }

  ngOnDestroy() {
    Object.keys(this.destroyComponent).forEach((key, i) => {
      if (this.destroyComponent[key]) {
        this.destroyComponent[key].unsubscribe();
      }
    });
  }
  pageChanged(event) {
    this.currentPage = event.page;
    this.pageOrder["pageNumber"] = event.page;
    this.getColumnData(this.pageOrder);
  }
  generate() {
    this.currentPage = 1;
    this.getColumnData(this.pageOrder);
  }

  blurOnChange(ev) {
    if (ev) {
      this.pageOrder["search"] = ev;
      this.pageOrder["pageNumber"] = 1;
      this.getColumnData(this.pageOrder, "blur");
    } else {
      this.pageOrder["search"] = "";
      this.pageOrder["pageNumber"] = 1;
      this.getColumnData(this.pageOrder, "blur");
    }
  }

  navigateToDashboard() {
    window.history.back();
  }
}
